import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AppContextProvider } from './context/AppContext';
import { NotifyProvider } from './components/NotifyProvider';
import Layout from './components/Layout';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import { WywBookingPage, WywTonightPage, WywEnterPage } from './pages/WywPublic';
import './App.css';

// Win Your Wedding pages for couples and hosts: no login, the link's token is the key.
function wywPublicPage() {
  try {
    const p = new URLSearchParams(window.location.search);
    if (p.get('wyw_book')) return <WywBookingPage token={p.get('wyw_book')} />;
    if (p.get('wyw_tonight')) return <WywTonightPage token={p.get('wyw_tonight')} />;
    if (p.get('wyw_enter')) return <WywEnterPage />;
  } catch (_) { /* no window */ }
  return null;
}

/**
 * AuthGate - Handles routing based on auth state
 * In demo mode (no Supabase configured), skips login entirely
 */
function AuthGate() {
  const { isAuthenticated, loading, isSupabaseConfigured } = useAuth();

  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
          <p className="text-gray-500 text-sm mt-3">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Reset password route - accessible to anyone with a valid token */}
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* If Supabase isn't configured, run in demo mode (no login required) */}
      {!isSupabaseConfigured && (
        <Route
          path="*"
          element={
            <AppContextProvider>
              <Layout />
            </AppContextProvider>
          }
        />
      )}

      {/* If Supabase is configured, require authentication */}
      {isSupabaseConfigured && (
        <>
          {!isAuthenticated && <Route path="*" element={<Login />} />}
          {isAuthenticated && (
            <Route
              path="*"
              element={
                <AppContextProvider>
                  <Layout />
                </AppContextProvider>
              }
            />
          )}
        </>
      )}
    </Routes>
  );
}

function App() {
  const publicPage = wywPublicPage();
  if (publicPage) return publicPage;
  return (
    <AuthProvider>
      <NotifyProvider>
        <BrowserRouter>
          <AuthGate />
        </BrowserRouter>
      </NotifyProvider>
    </AuthProvider>
  );
}

export default App;
